/* eslint-disable react/prop-types */
import {
  Col,
  Form,
  Input,
  Row,
  Spin,
} from 'antd';
import Select from 'components/Select';
import Table from 'components/Table';
import React from 'react';

const { TextArea } = Input;

const UsuariosRoles = ({
  form,
  roles,
  funciones,
  permisos,
  loading,
  selectedPermissions,
  setSelectedPermissions,
  disableEditar,
}) => {
  const columns = [
    {
      titleText: 'Permiso',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedPermissions,
    type: 'checkbox',
    onSelect: (record, selected) => {
      if (selected) {
        setSelectedPermissions([...selectedPermissions, record.id]);
      } else {
        setSelectedPermissions(selectedPermissions.filter((id) => id !== record.id));
      }
    },
    onSelectAll: (selected) => {
      setSelectedPermissions(selected ? permisos.map((p) => p.id) : []);
    },
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="roles"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item name="roles" label="Roles">
                <Select
                  mode="multiple"
                  keyProp="id"
                  labelProp="name"
                  dataSource={roles}
                  onChange={(vals) => {
                    const allPermissions = [
                      ...new Set(
                        (vals || []).flatMap((roleId) => {
                          const roleObj = roles.find((r) => r.id === roleId);
                          return roleObj?.permissions || [];
                        }),
                      ),
                    ];
                    setSelectedPermissions(allPermissions);
                  }}
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10} style={{ display: 'none' }}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="funcion" label="Función">
                <Select
                  dataSource={funciones}
                  onChange={(val) => {
                    const _funcion = funciones.find((e) => e.id === val);
                    form.setFieldValue('justificacion', _funcion?.justificacion);
                  }}
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="justificacion" label="Justificación">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={24}>
              <Form.Item name="observaciones" label="Observaciones">
                <TextArea
                  row={3}
                  allowClear
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Permisos</p>
            <Table
              data={permisos}
              cols={columns}
              rowSelection={rowSelection}
            />
          </Row>
        </Form>
      </Spin>
    </Row>
  );
};

export default UsuariosRoles;
